var exports = {
  "KC": "AuthorizedAppsTab.module__appList___WW5fbX",
  "Um": "AuthorizedAppsTab.module__appCard___WW5fbX",
  "sK": "AuthorizedAppsTab.module__appCardSelectable___WW5fbX",
  "nD": "AuthorizedAppsTab.module__appMain___WW5fbX",
  "tR": "AuthorizedAppsTab.module__appActions___WW5fbX",
  "FG": "AuthorizedAppsTab.module__appAvatar___WW5fbX",
  "O5": "AuthorizedAppsTab.module__appAvatarImage___WW5fbX",
  "Q2": "AuthorizedAppsTab.module__appAvatarPlaceholder___WW5fbX",
  "fI": "AuthorizedAppsTab.module__textBlock___WW5fbX",
  "JB": "AuthorizedAppsTab.module__appName___WW5fbX",
  "v8": "AuthorizedAppsTab.module__metaText___WW5fbX",
  "gb": "AuthorizedAppsTab.module__iconButton___WW5fbX",
  "R5": "AuthorizedAppsTab.module__revokeButton___WW5fbX",
  "gE": "AuthorizedAppsTab.module__actionIcon___WW5fbX",
  "Qn": "AuthorizedAppsTab.module__selectionHint___WW5fbX",
  "Jb": "AuthorizedAppsTab.module__scopeList___WW5fbX",
  "DL": "AuthorizedAppsTab.module__scopeTag___WW5fbX",
  "OK": "AuthorizedAppsTab.module__scopeName___WW5fbX",
  "RJ": "AuthorizedAppsTab.module__scopeDescription___WW5fbX",
  "g4": "AuthorizedAppsTab.module__loadingContainer___WW5fbX",
};

module.exports = exports;
